import BasicInfo from './BasicInfo';
import FrequencyCaps from './FrequencyCaps';
import PacingSection from './PacingSection';
import ProductAndPublishersSelection from './ProductAndPublishersSelection';

const components = [BasicInfo, ProductAndPublishersSelection, FrequencyCaps, PacingSection];

interface IProps {
  index: number;
}

const LineItemFormBasicSection = (props: IProps) => {
  return components.map((Component, index) => <Component key={index} {...props} />);
};

export default LineItemFormBasicSection;
